import { css } from "styled-components"

const families = {
  primary: `"Inter", sans-serif`,
  secondary: `"Inter", sans-serif`,
}

const weights = {
  primary: {
    normal: 400,
    bold: 700,
    black: 900,
  },
  secondary: {
    normal: 400,
    bold: 700,
    black: 900,
  },
}

const set = (family, weight) => {
  try {
    return css`
      font-family: ${families[family]};
      font-weight: ${weights[family][weight]};
    `
  } catch (e) {
    // eslint-disable-next-line no-console
    return console.error(`Undefined font family/weight`, e.message, e.name)
  }
}

export default {
  set,
}
